export function randomFromArray(array) {
  return array[Math.floor(Math.random() * array.length)];
}

export default randomFromArray;



// WEBPACK FOOTER //
// ./src/helpers/random-from-array.js